import { useSession } from '../Components/Session';
import { useJournalCounts } from './Journal';
import { useUnreadThreads } from './Messages';

const useHomeBadge = () => {
    const {business, notificationBadge} = useSession();
    const {counts} = useJournalCounts();
    const {unread} = useUnreadThreads();

    const businessSwitcherBadge = counts && business ?
        counts.reduce((acc, count) => count.businessId === business.id ? acc : acc + count.count, 0) > 0 : false;

    const inboxBadge = unread?.length > 0;

    return businessSwitcherBadge || inboxBadge || notificationBadge;
}

export default useHomeBadge;
